import React, { useContext } from 'react';
import { useHasYScrolled } from '../../hooks/use-has-y-scrolled';
import { jsx as _jsx } from "react/jsx-runtime";
const HeaderContext = /*#__PURE__*/React.createContext(undefined);
const transparentScrollThreshold = 10;
export const HeaderProvider = ({
  route,
  config,
  children
}) => {
  const isHome = route.pageId === 'home';
  const hasScrolled = useHasYScrolled(transparentScrollThreshold);
  const state = {
    route,
    config,
    hasSecondLevelNavi: !!config.secondLevelNavigation,
    showMainNavi: config.mainNavigation.length > 0,
    showMainNaviOnSmallScreens: isHome,
    smallMainNavi: !isHome,
    hasScrolled,
    layout: route.layout?.header || 'default'
  };
  return /*#__PURE__*/_jsx(HeaderContext.Provider, {
    value: state,
    children: children
  });
};
export const useHeaderState = () => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeaderState must be used within a HeaderProvider');
  }
  return context;
};